import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager, AlertService } from 'ng-jhipster';
import { Card } from './card.model';
import { CardService } from './card.service';
import { PaymentItem, PaymentItemService} from '../payment-item/';
import { Reservation, ReservationService, ReservationUtilService } from '../../entities/reservation';
import { Subscription } from 'rxjs/Subscription';
import { CRUD_ACTIONS, CARD_UNLIMITED_BOOKINGS_NUMBER } from '../../shared';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-card-detail',
    templateUrl: './card-detail.component.html'
})
export class CardDetailComponent implements OnInit, OnDestroy {

    card: Card;
    private subscription: any;
    private cardSubscription: Subscription;
    private paymentItemSubscription: any;
    paymentItems: PaymentItem[];
    paymentItemsTotalAmount = 0;
    readonly MAX_PAYMENT_ITEMS = 50;
    readonly UNLIMITED_BOOKINGS = CARD_UNLIMITED_BOOKINGS_NUMBER;
    reservations: Reservation[];
    private isLoadingReservations: boolean = false;
    availableBookings: number;
    showBuyCardBanner: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private cardService: CardService,
        private eventManager: EventManager,
        private paymentItemService: PaymentItemService,
        private reservationService: ReservationService,
        private reservationUtilService: ReservationUtilService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['card', 'cardType', 'payment', 'paymentType', 'paymentItem',
                                              'reservation', 'reservationStatus']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });

        this.cardSubscription = this.eventManager
                .subscribe('cardListModification',
                (response) => {
                    let previousFromDate = new Date(this.card.validSince);
                    let previousToDate = new Date(this.card.validUntil);
                    let updatedCard = response['content']['content'];

                    // we transform the dates from string if needed
                    if (updatedCard && updatedCard.validSince && updatedCard.validUntil) {
                        let fromDate: Date = new Date(updatedCard.validSince);
                        let toDate: Date = new Date(updatedCard.validUntil);
                        if (previousFromDate.getTime() !== fromDate.getTime() || previousToDate.getTime() !== toDate.getTime()) {
                            // we only load the reservations if the dates have changed
                            this.loadReservations(updatedCard.student.id, fromDate, toDate);
                        }
                    }
                    this.card = updatedCard;
                });
        this.paymentItemSubscription = this.eventManager
            .subscribe('paymentItemListModification', (response) => {
                this.handleActionResult(response.content);
            });
    }

    private handleActionResult(result: { action: string, content: any }) {
        switch (result.action) {
            case CRUD_ACTIONS.CREATE:
                this.paymentItems.push(result.content);
                this.calculateTotalAmount();
                break;
            case CRUD_ACTIONS.UPDATE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    let currentItem = this.paymentItems[index];
                    if (currentItem.id === result.content.id) {
                        if (currentItem.card === result.content.card) {
                            currentItem = result.content;
                        } else {
                            // the paiment item has change of product, we have to remove it from the list
                            this.paymentItems.splice(index, 1);
                        }
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
            case CRUD_ACTIONS.DELETE:
                for (let index = 0; index <= this.paymentItems.length - 1; index++) {
                    if (this.paymentItems[index].id === result.content.id) {
                        this.paymentItems.splice(index, 1);
                        this.calculateTotalAmount();
                        break;
                    }
                }
                break;
        }
    }

    load(id) {
        this.cardService.find(id).subscribe(card => {
            this.card = card;
            this.availableBookings = this.cardService.getAvailableAssistances(this.card);
            if (this.availableBookings <= 0 || this.isCardExpired()) {
                this.showBuyCardBanner = true;
            }
            this.loadPaymentItems(card.id);
            this.loadReservations(card.student.id, card.validSince, card.validUntil);
        });
    }

    isCardExpired(): boolean {
        const today = new Date();
        today.setHours(0, 0, 0, 0);  // Set today's time to midnight

        const validUntilDate = new Date(this.card.validUntil);
        validUntilDate.setHours(0, 0, 0, 0);  // Set validUntil time to midnight

        return validUntilDate < today;
      }

    private loadPaymentItems(id: number) {
        this.paymentItemService.search({
            query: 'card.id:' + id,
            size: this.MAX_PAYMENT_ITEMS,
            sort: ['payment.id', 'desc']
        }).subscribe(
            (res: HttpResponse<PaymentItem[]>) => this.onPaymentItemSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    private onPaymentItemSuccess(data, headers) {
        this.paymentItems = data;
        this.calculateTotalAmount();
    }

    private loadReservations(studentId: number, from: Date, to: Date) {
        if (!this.card || this.card.maxAssistancesNum >= CARD_UNLIMITED_BOOKINGS_NUMBER ) {
            // we do not want to load the reservations if the card has unlimited bookings
            return;
        }

        this.isLoadingReservations = true;

        let dayFrom = from.getDate();
        let monthFrom = from.getMonth() + 1;
        let dayTo = to.getDate();
        let monthTo = to.getMonth() + 1;

        let realDayFrom = dayFrom < 10 ? '0' + dayFrom : dayFrom;
        let realMonthFrom = monthFrom < 10 ? '0' + monthFrom : monthFrom;
        let realDayTo = dayTo < 10 ? '0' + dayTo : dayTo;
        let realMonthTo = monthTo < 10 ? '0' + monthTo : monthTo;

        let query = 'student.id:' + studentId +
            ' AND !(status:CANCELLED OR status:LESSON_CANCELLED)' +
            ' AND lesson.begining:[' + from.getFullYear() +
            '-' + realMonthFrom + '-' + realDayFrom + ' TO ' + to.getFullYear() + '-' + realMonthTo + '-' + realDayTo + ']' +
            ' AND !(lesson.free:true)';


        this.reservationService
            .search({
                query: query,
                sort: 'lesson.begining,desc',
                size : CARD_UNLIMITED_BOOKINGS_NUMBER
            }).subscribe(
                (res: HttpResponse<Reservation[]>) => this.onReservationSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
            );

    }

    private onReservationSuccess(data: Reservation[], headers: any) {
        this.reservations = data;
        this.isLoadingReservations = false;
    }

    getReservationBadgeStyle(reservation: Reservation): String {
        if (reservation) {
            return this.reservationUtilService.getReservationBadgeStyle(
                reservation.status.toString());
        }
        return 'badge-info';
    }

    previousState() {
        window.history.back();
    }

    private calculateTotalAmount() {
        this.paymentItemsTotalAmount = 0;
        this.paymentItems.forEach((paymentItem) => {
            this.paymentItemsTotalAmount += paymentItem.amount;
        });
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.cardSubscription.unsubscribe();
        this.paymentItemSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card/card-detail.component.ts